<template>
  <div class="card shadow-sm h-100">
    <div class="p-4 pb-0 card-header">
      <div class="row">
        <div class="col-md-8 d-flex align-items-center">
          <h6 class="mb-0">{{ title }}</h6>
        </div>
      </div>
    </div>
    <div class="p-4 card-body">
      <ul class="list-group">
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">GTIN:</strong> &nbsp; {{ info.gtin }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">제조사:</strong> &nbsp; {{ info.manufacturer?.name }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">제품명:</strong> &nbsp; {{ info.name }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">분류:</strong> &nbsp; {{ info.category }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">EPC 타입:</strong> &nbsp; {{ info.epcType }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">단위:</strong> &nbsp; {{ info.unit }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">등록일:</strong> &nbsp; {{ formatDate(info.createdAt) }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">최종수정일:</strong> &nbsp; {{ formatDate(info.updatedAt) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: "ProfileInfoCard",
  components: {
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
